import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Form } from "@/mk2/components/Form";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { SEARCH_IN_FORUM } from "@/mk/autogenerated/translations/SearchPanel.45d0c4026fb7ee4706015c029a626c85";

import styles from "./SearchPanel.mscss";

interface OwnProps {
    className?: string;
    onSubmit?(searchQuery: string);
}

type Props = OwnProps;

const SearchPanel = React.memo<Props>(({ className, onSubmit }) => {
    const [query, setQuery] = React.useState("");
    const onChange = useEventCallback(
        (event: React.FormEvent<HTMLInputElement>) => {
            setQuery(event.currentTarget.value);
        },
        [setQuery],
    );
    const onSubmitHandler = useEventCallback(
        (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            onSubmit(query);
        },
        [query, onSubmit],
    );

    return (
        <Form className={cx(styles.SearchPanel, className)} onSubmit={onSubmitHandler}>
            <FontAwesomeIcon icon={faSearch} className={styles.SearchPanel__icon} />

            <input
                className={styles.SearchPanel__input}
                type="text"
                placeholder={SEARCH_IN_FORUM}
                onChange={onChange}
            />
        </Form>
    );
});

SearchPanel.displayName = "SearchPanel";

export default SearchPanel;
